import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Pagination from '../../../components/common/Pagination';
import optionsIcon from '../../../images/icon-vert-dots.svg';
import editIcon from '../../../images/icon-editing.svg';
import deleteIcon from '../../../images/icon-trash.svg';

import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css'; 

const RecipesTable = ({ onEdit, onDelete, handlePageChange }) => {
  const { recipes, currentRecipePage, totalRecipePages } = useSelector((state) => state.admin_recipes);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredRecipes, setFilteredRecipes] = useState(recipes);
  const [activeDropdown, setActiveDropdown] = useState(null);

  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
  
  const toggleDropdown = (id, event) => {
    if (activeDropdown === id) { 
      setActiveDropdown(null);
    } else {
      const rect = event.target.getBoundingClientRect();
      setDropdownPosition({ top: rect.bottom, left: rect.left-100 });
      setActiveDropdown(id);
    }
  };

  useEffect(() => {
    if (recipes) {
    const filtered = recipes.filter(recipe => 
      recipe.meal_name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredRecipes(filtered);
  } else {
    setFilteredRecipes([]);
  }
    
  }, [recipes, searchTerm]);

  const handleDelete = (id) => {
    confirmAlert({
      title: 'Confirm Deletion',
      message: 'Are you sure you want to delete this recipe?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => onDelete(id)
        },
        {
          label: 'No',
          onClick: () => {}
        }
      ]
    });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.dropdown-toggle') && !event.target.closest('.dropdown-menu')) {
        setActiveDropdown(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

   const handleScroll = () => {
    setActiveDropdown(null);
  };

  useEffect(() => {
      window.addEventListener('scroll', handleScroll, true);
    return () => {
      window.removeEventListener('scroll', handleScroll, true);
    };
  }, []);

  return (
      <> 
      <div className="table-responsive">
        <table className="table table-striped table-users table-alex printarea">
          <thead>
            <tr>
              <th>Recipe Name</th>
              <th>Ingredients Count</th>
              <th>Protein</th>
              <th>Carb</th>
              <th>Fat</th>
              <th className="noprint">Action</th>
            </tr>
          </thead>
          <tbody>
            {filteredRecipes && filteredRecipes.length > 0 ? filteredRecipes.map((recipe) => (
              <tr key={recipe.id}>
                <td>
                  <div className="text-start d-flex align-items-center">
                    <div className="img-placeholder me-2">
                      {recipe.meal_picture_full_url ? (
                        <img src={recipe.meal_picture_full_url} alt={recipe.meal_name || 'Meal'} className="img-thumbnail" />
                      ) : (
                        <p>No Image</p>
                      )}
                    </div>
                    <span>{recipe.meal_name || 'Default Recipe Name'}</span>
                  </div>
                </td>
                <td>
                  {recipe.ingredients?.length 
                    ? `${recipe.ingredients.length}`
                    : 'No ingredients added'}
                </td>
                <td>{recipe.protein}</td>
                <td>{recipe.carb}</td>
                <td>{recipe.fat}</td>
                <td className="noprint">
                  <div className="text-center position-relative">
                    <button 
                      type="button" 
                      className="bg-transparent border-0 p-0 dropdown-toggle btn-vert-dots" 
                      onClick={(e) => toggleDropdown(recipe.id, e)}
                    >
                      <img src={optionsIcon} alt="Options" />
                    </button>
                    {activeDropdown === recipe.id && (
                     <ul className="dropdown-menu dropdown-menu-end" 
                      style={{  display: 'block',
                            position: 'fixed',
                            top: `${dropdownPosition.top}px`,
                            left: `${dropdownPosition.left}px`,
                            width: `200px`,
                            zIndex: 1050, }}
                      >  
                        <li>
                          <a className="dropdown-item" onClick={() => onEdit(recipe)}>
                            <img src={editIcon} alt="Edit" /> Edit
                          </a>
                        </li>

                        {localStorage.getItem("486478dh784dh4dh4d4h64nngx4c5v6bnyx7xnnvxsrdese") == "1" && (
                          <li>
                            <a className="dropdown-item" onClick={() => handleDelete(recipe.id)}>
                              <img src={deleteIcon} alt="Delete" /> Delete
                            </a>
                          </li>
                        )}
                      </ul>
                    )}
                  </div>
                </td>
              </tr>
            )) : (
              <tr>
                <td colSpan="6" className="text-center">No recipes found.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <Pagination 
        currentPage={currentRecipePage} 
        totalPages={totalRecipePages} 
        onPageChange={handlePageChange} 
      />
    </>
  );
};

export default RecipesTable;